// extracted by mini-css-extract-plugin
export default {"modalContainer":"style_modalContainer__XkTNE","title":"style_title__zbeko","description":"style_description__Zx746","btn":"style_btn__ySkhe"};